module.exports = __webpack_public_path__ + "static/RJM_logo-7f1ed22900904a28eb799db2823945a3.png";